import React from 'react';
import { useModal } from '../../../context/ModalContext';
import './ModalBase.scss';

interface Props {
  children: React.ReactNode;
}

export function ModalBase({ children }: Props) {
  const { closeModal } = useModal();

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) closeModal();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-box">
        <button className="modal-box__close" onClick={closeModal} aria-label="Fechar">
          ✕
        </button>
        {children}
      </div>
    </div>
  );
}
